import { Button } from "@/components/ui/button";
import {
  useUpdatePartnerMutation,
  useGetPartnersQuery,
  useDeletePartnerMutation, 
} from "@/features/api/partnersApi";
import { useNavigate } from "react-router-dom";
import { Edit, Plus, Trash, Trash2 } from "lucide-react"; 
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

const PartnerList = () => {
  const { data: partners = [], isLoading, error } = useGetPartnersQuery();
  const [updatePartner] = useUpdatePartnerMutation();
  const [deletePartner, { isLoading: isDeleting }] = useDeletePartnerMutation(); 
  const navigate = useNavigate();

  if (isLoading) return <p>Loading...</p>;
  if (error)
    return (
      <p className="text-red-600">
        Error: {error?.data?.message || error.message || "Unknown error"}
      </p>
    );

  const handleStatusChange = async (id, newStatus) => {
    try {
      await updatePartner({ id, formData: { status: newStatus } }).unwrap();
    } catch (err) {
      console.error("Failed to update status", err);
    }
  };

const handleDelete = async (id) => {
  const confirmed = window.confirm("Are you sure you want to delete this partner?");
  if (!confirmed) return; // Exit if user selects "No"

  try {
    console.log("Deleting partner with ID:", id);
    await deletePartner(id).unwrap();
    console.log("Partner deleted successfully");
  } catch (err) {
    console.error("Delete error:", err);
  }
};




  return (
    <div className="flex-1 p-6 bg-background min-h-screen">
  <div className="flex flex-col md:flex-row md:items-center justify-between mb-6 gap-4">
    <h2 className="text-2xl font-semibold">🤝 Partner Applications</h2>
        <Button
          onClick={() => navigate("/admin/partners/create")}
          className="flex items-center gap-2"
        >
          <Plus size={18} />
          Create Partner
        </Button>
      </div>

      <Table>
        <TableCaption>A list of all submitted partner applications</TableCaption>
        <TableHeader>
          <TableRow>
            <TableHead>#</TableHead>
            <TableHead>Full Name</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Phone</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Date</TableHead>
            <TableHead className="text-center">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
         {partners.map((partner, index) => (
  <TableRow key={partner._id ?? index}>
    <TableCell>{index + 1}</TableCell>
    <TableCell>{partner.fullName || partner.name || "-"}</TableCell>
    <TableCell>{partner.email || "-"}</TableCell>
    <TableCell>{partner.phone || "-"}</TableCell>
    <TableCell className="capitalize">{partner.status || "-"}</TableCell>
    <TableCell>
      {partner.createdAt
        ? new Date(partner.createdAt).toLocaleDateString()
        : "-"}
    </TableCell>
    <TableCell className="text-center flex gap-2 justify-end">
      <Button
        variant="outline"
        size="icon"
        onClick={() => navigate(`/admin/partners/${partner._id}`)}
        title="Edit Partner"
      >
        <Edit size={18} />
      </Button>

      <Button
        variant="destructive"
        size="icon"
        disabled={isDeleting}
        onClick={() => handleDelete(partner._id)}
        title="Delete Partner"
      >
        <Trash size={18} />
      </Button>
    </TableCell>
  </TableRow>
))}

        </TableBody>
      </Table>
    </div>
  );
};

export default PartnerList;
